// extracted by mini-css-extract-plugin
export default {"toggleWrapper":"ToggleSwitch_toggleWrapper__0TPMG","option":"ToggleSwitch_option__j18FA","active":"ToggleSwitch_active__FNBNF","activeBg":"ToggleSwitch_activeBg__V07kc"};